import NotificationRemaindersTable from './NotificationRemaindersTable'

export default NotificationRemaindersTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/NotificationRemaindersTable/index.js